<template>
    <div class="canvas-layout">
        <div class="canvas-header">
            <slot name="header"/>
        </div>
        <div class="canvas-content">
            <slot/>
        </div>
    </div>
</template>

<script>
import CanvasHeader from "@/Components/StudentCanvas/CanvasHeader";
import jQuery from "jquery";
export default {
    name: "CanvasLayout",
    components: {CanvasHeader},
    props: {

    },

    methods: {
        layoutUpdate(){
            jQuery('.canvas-content').css({
                'padding-top': jQuery('.canvas-header').height() + 'px',
            });
        }
    },

    mounted() {
        this.layoutUpdate();
        jQuery(window)
            .on('load', this.layoutUpdate)
            .on('resize', this.layoutUpdate);
    },

    beforeUnmount() {
        jQuery(window)
            .off('load', this.layoutUpdate)
            .off('resize', this.layoutUpdate);
    }

}
</script>

<style lang="scss" scoped>
.canvas-header{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    box-shadow: rgba(black, 0.1) 0 3px 5px;
    z-index: 10;
    background: white;
}
</style>
